import {useEffect, useMemo, useRef} from "react";

import {setAmplitudeUserProperties, trackAmplitudeEvent} from "@pg-mono/amplitude";

import {getAmplitudeFlowTracking} from "../../auth/utils/get_amplitude_flow_tracking";
import {useAppSelector} from "../../store/hooks";
import {AmplitudeModalLocation, trackAmplitudeViewModal} from "../../tracking/amplitude/track_amplitude_view_modal";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {ViewType} from "../../view_type/ViewType";

export interface IAmplitudePhoneVerificationContext {
    location: AmplitudeModalLocation;
    phoneVerifyPlacement: AmplitudeAuthPlacement | null;
    authPlacement?: AmplitudeAuthPlacement | null;
}

const EMPTY_PHONE_VERIFICATION_CONTEXT: IAmplitudePhoneVerificationContext = {
    location: null,
    phoneVerifyPlacement: null
};

/*
 * `phone_verified` event spec: send `true` after the user verifies the phone number with a correct SMS code,
 * `false` when the verification popup is closed or the verification attempt fails.
 * A successful verification is additionally stored in Amplitude user properties.
 */
export const trackAmplitudePhoneVerified = (isPhoneVerified: boolean, context: IAmplitudePhoneVerificationContext = EMPTY_PHONE_VERIFICATION_CONTEXT) => {
    trackAmplitudeEvent("phone_verified", {
        phone_verified: isPhoneVerified,
        location: context.location,
        phone_verify_placement: context.phoneVerifyPlacement,
        ...(context.authPlacement !== undefined && {auth_placement: context.authPlacement})
    });

    if (isPhoneVerified) {
        setAmplitudeUserProperties({phone_verified: true});
    }
};

export const getAmplitudeScreenLocation = (viewType: ViewType | null): AmplitudeModalLocation => {
    switch (viewType) {
        case ViewType.HOMEPAGE:
            return "homepage";
        case ViewType.OFFER:
            return "investment_page";
        case ViewType.PROPERTY:
            return "property_page";
        case ViewType.OFFER_LIST:
        case ViewType.OFFER_LIST_ABROAD:
        case ViewType.PROMOTION_LIST:
            return "listing_page";
        case ViewType.OFFER_LIST_MAP:
        case ViewType.OFFER_LIST_MAP_ABROAD:
            return "listing_map";
        default:
            return null;
    }
};

export type PhoneVerificationPlacementSource = "registrationFlow" | "mainLead";

export const usePhoneVerificationAmplitudeContext = (placementSource: PhoneVerificationPlacementSource): IAmplitudePhoneVerificationContext => {
    const viewType = useAppSelector((state) => state.viewType.current);
    const amplitudePlacement = useAppSelector((state) =>
        placementSource === "registrationFlow" ? state.registrationFlow.amplitudePlacement : state.mainLead.amplitudePlacement
    );
    const amplitudeLocation = useAppSelector((state) => (placementSource === "registrationFlow" ? state.registrationFlow.amplitudeLocation : undefined));

    return useMemo(() => {
        const {placement, location} = getAmplitudeFlowTracking({amplitudePlacement, amplitudeLocation}, getAmplitudeScreenLocation(viewType));

        return {location, phoneVerifyPlacement: placement};
    }, [amplitudeLocation, amplitudePlacement, viewType]);
};

export const useTrackAmplitudePhoneVerifyModalView = (context: IAmplitudePhoneVerificationContext): void => {
    const isTrackedRef = useRef(false);

    useEffect(() => {
        if (isTrackedRef.current) {
            return;
        }

        isTrackedRef.current = true;
        trackAmplitudeViewModal({modalName: "phone_verify", location: context.location, phoneVerifyPlacement: context.phoneVerifyPlacement});
    }, [context]);
};
import {useEffect, useMemo, useRef} from "react";

import {setAmplitudeUserProperties, trackAmplitudeEvent} from "@pg-mono/amplitude";

import {getAmplitudeFlowTracking} from "../../auth/utils/get_amplitude_flow_tracking";
import {useAppSelector} from "../../store/hooks";
import {AmplitudeModalLocation, trackAmplitudeViewModal} from "../../tracking/amplitude/track_amplitude_view_modal";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {ViewType} from "../../view_type/ViewType";

export interface IAmplitudePhoneVerificationContext {
    location: AmplitudeModalLocation;
    phoneVerifyPlacement: AmplitudeAuthPlacement | null;
    authPlacement?: AmplitudeAuthPlacement | null;
}

const EMPTY_PHONE_VERIFICATION_CONTEXT: IAmplitudePhoneVerificationContext = {
    location: null,
    phoneVerifyPlacement: null
};

/*
 * `phone_verified` event spec: send `true` after the user verifies the phone number with a correct SMS code,
 * `false` when the verification popup is closed or the verification attempt fails.
 * A successful verification is additionally stored in Amplitude user properties.
 */
export const trackAmplitudePhoneVerified = (isPhoneVerified: boolean, context: IAmplitudePhoneVerificationContext = EMPTY_PHONE_VERIFICATION_CONTEXT) => {
    trackAmplitudeEvent("phone_verified", {
        phone_verified: isPhoneVerified,
        location: context.location,
        phone_verify_placement: context.phoneVerifyPlacement,
        ...(context.authPlacement !== undefined && {auth_placement: context.authPlacement})
    });

    if (isPhoneVerified) {
        setAmplitudeUserProperties({phone_verified: true});
    }
};

export const getAmplitudeScreenLocation = (viewType: ViewType | null): AmplitudeModalLocation => {
    switch (viewType) {
        case ViewType.HOMEPAGE:
            return "homepage";
        case ViewType.OFFER:
            return "investment_page";
        case ViewType.PROPERTY:
            return "property_page";
        case ViewType.OFFER_LIST:
        case ViewType.OFFER_LIST_ABROAD:
        case ViewType.PROMOTION_LIST:
            return "listing_page";
        case ViewType.OFFER_LIST_MAP:
        case ViewType.OFFER_LIST_MAP_ABROAD:
            return "listing_map";
        default:
            return null;
    }
};

export type PhoneVerificationPlacementSource = "registrationFlow" | "mainLead";

export const usePhoneVerificationAmplitudeContext = (placementSource: PhoneVerificationPlacementSource): IAmplitudePhoneVerificationContext => {
    const viewType = useAppSelector((state) => state.viewType.current);
    const amplitudePlacement = useAppSelector((state) =>
        placementSource === "registrationFlow" ? state.registrationFlow.amplitudePlacement : state.mainLead.amplitudePlacement
    );
    const amplitudeLocation = useAppSelector((state) => (placementSource === "registrationFlow" ? state.registrationFlow.amplitudeLocation : undefined));

    return useMemo(() => {
        const {placement, location} = getAmplitudeFlowTracking({amplitudePlacement, amplitudeLocation}, getAmplitudeScreenLocation(viewType));

        return {location, phoneVerifyPlacement: placement};
    }, [amplitudeLocation, amplitudePlacement, viewType]);
};

export const useTrackAmplitudePhoneVerifyModalView = (context: IAmplitudePhoneVerificationContext): void => {
    const isTrackedRef = useRef(false);

    useEffect(() => {
        if (isTrackedRef.current) {
            return;
        }

        isTrackedRef.current = true;
        trackAmplitudeViewModal({modalName: "phone_verify", location: context.location, phoneVerifyPlacement: context.phoneVerifyPlacement});
    }, [context]);
};
